// extracted by mini-css-extract-plugin
export default {"mainInfo":"MedreseInfo_mainInfo__kXEnw","header":"MedreseInfo_header__RkjO4","column":"MedreseInfo_column__HzbYJ"};